import _ from 'lodash';
import { INTERNAL_ID_FIELD } from '../../form/FormConstants';

export const removeAtIndex = (items = [], indexToRemove) => {
    return (items || []).filter((_item, index) => index !== indexToRemove);
};

export const normalizeSectionsForUi = (sourceSections = []) => {
    return (sourceSections || []).map((section) => ({
        ...section,
        [INTERNAL_ID_FIELD]: section?.[INTERNAL_ID_FIELD] || section?._uiId || _.uniqueId('section_'),
        fields: (section?.fields || []).map((row) => {
            // Support legacy format where row is a plain array (possibly with _uiId custom prop)
            const isLegacyRow = _.isArray(row);
            const rowFields = isLegacyRow ? row : row?.fields || [];
            const rowId = isLegacyRow
                ? row?._uiId || _.uniqueId('row_')
                : row?.[INTERNAL_ID_FIELD] || _.uniqueId('row_');

            return {
                [INTERNAL_ID_FIELD]: rowId,
                fields: (rowFields || []).map((field) => {
                    const normalizedField = {
                        ...field,
                        [INTERNAL_ID_FIELD]: field?.[INTERNAL_ID_FIELD] || field?._uiId || _.uniqueId('field_'),
                    };

                    if (_.isArray(normalizedField?.options)) {
                        normalizedField.options = normalizedField.options.map((option) => ({
                            ...option,
                            [INTERNAL_ID_FIELD]: option?.[INTERNAL_ID_FIELD] || option?._uiId || _.uniqueId('option_'),
                        }));
                    }

                    return normalizedField;
                }),
            };
        }),
    }));
};

export const serializeSectionsForSave = (sourceSections = []) => {
    return (sourceSections || []).map((section) => ({
        ..._.omit(section, [INTERNAL_ID_FIELD, '_uiId']),
        fields: (section?.fields || []).map((row) => {
            const rowFields = _.isArray(row) ? row : row?.fields || [];

            return rowFields.map((field) => {
                const serializedField = _.omit(field, [INTERNAL_ID_FIELD, '_uiId']);

                if (_.isArray(serializedField?.options)) {
                    serializedField.options = serializedField.options.map((option) =>
                        _.omit(option, [INTERNAL_ID_FIELD, '_uiId'])
                    );
                }

                return serializedField;
            });
        }),
    }));
};
